import React, { createContext, useContext, useState } from 'react';

const TranslationContext = createContext();

const translations = {
  en: {
    navbar: {
      title: 'Tech & Digital Marketing',
      menu: 'Menu',
      home: 'Home',
      about: 'About',
      contact: 'Contact',
      themeSwitch: 'Light/Dark',
    },
    landing: {
      title: 'Hi there 👋',
      description:
        "Passionate about programming and digital marketing, I design and deploy comprehensive digital solutions, from user interfaces to back-end services: websites, software, applications, video games, APIs, and custom integrations. I also have strong skills in SEO, ASO, and advertising campaign management, enabling me to deliver measurable results.",
      contactBtn: 'Contact',
      typed1: 'I am Jean-Joseph',
      typed2: 'I am a Full-Stack Developer',
      typed3: 'a Video Game Developer',
      typed4: 'and a Digital Marketing Expert',
    },
    about: {
      title: 'To sum up :',
      description1: '- HTML, CSS, C#, JavaScript, Python, TypeScript, PHP',
      description2:
        '- Libraries & Frameworks: jQuery, React, Django, Node.js frameworks (NestJs, Express.js), Nextjs, Material UI, and Bootstrap',
      description3: '- Version Control & Development Tools: Git, GitHub, npm, Visual Studio Code, Sublime Text',
      description4: '- Cloud Technologies: Cloud Native practices, DevOps, CI/CD',
      description5: '- Containerization: Docker, Kubernetes, OpenShift',
      description6: '- Database Management: SQL, NoSQL',
      description7: '- Microservices and Serverless Computing',
      description8: '- Video Game Development',
      description9: '- CMS : WordPress',
      description10: '- Recommended approaches in cybersecurity',
      description11: '- Effective methods for SEO, GEO and advertising campaign management',
      description12: '- Key principles for ASO (App Store Optimization)',
      description13:
        '- Tracking & analytics: GTM, event tracking implementation, CAPI, SKAN, MACT, performance dashboards',
      description14: '- Conversion funnel optimization',
      description15: '- API integration & ROI-driven digital strategy',
      description16: (
        <>
          - GitHub Repositories:{' '}
          <a
            href="https://github.com/Jean-Joooo?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
            title="View My Codes"
            className="custom-link"
          >
            View My Codes
          </a>
        </>
      ),
      description17: (
        <>
          - Unity Dev Profile:{' '}
          <a
            href="https://play.unity.com/en/user/22629c72-4d39-48ff-bed8-08491b47a243"
            target="_blank"
            rel="noopener noreferrer"
            title="See My Games Creations"
            className="custom-link"
          >
            See My Games Creations
          </a>
        </>
      ),
      description18:
        'My goal is to amplify your vision, increase your ROAS, and turn your concepts into a digital masterpiece.',
    },
    projects: {
      title: 'Accomplishments',
    },
    skills: {
      title: 'I mainly use',
    },
    contacts: {
      name: 'Name/ Company Name',
      placeholder: 'Ashley Giraud/ Company XYZ',
      PhoneNumber: 'Phone Number',
      Subject: 'Subject',
      message: 'Type your message',
      sendBtn: 'Send',
    },
  },

  fr: {
    navbar: {
      title: 'Tech & Marketing Digital',
      menu: 'Menu',
      home: 'Accueil',
      about: 'À propos',
      contact: 'Contact',
      themeSwitch: 'Clair/Sombre',
    },
    landing: {
      title: 'Bonjour 👋',
      description:
        "Passionné par la programmation et le marketing digital, je conçois et déploie des solutions numériques complètes, de l’interface utilisateur aux services back-end : sites web, logiciels, applications, jeux vidéo, API et intégrations sur mesure. J’ai également de solides compétences en SEO, ASO et en gestion de campagnes publicitaires, ce qui me permet de générer des résultats concrets et mesurables.",
      contactBtn: 'Contact',
      typed1: "Je m'appelle Jean-Joseph",
      typed2: 'Je suis un développeur Full-Stack',
      typed3: 'un Développeur de Jeux Vidéo',
      typed4: 'et un expert en Marketing Digital',
    },
    about: {
      title: 'En résumé :',
      description1: '- Langages : HTML, CSS, C#, JavaScript, Python, TypeScript, PHP',
      description2:
        '- Bibliothèques et Frameworks : jQuery, React, Django, frameworks Node.js (NestJS, Express.js), Next.js, Material UI, et Bootstrap',
      description3: '- Contrôle de version & outils de développement : Git, GitHub, npm, Visual Studio Code, Sublime Text',
      description4: '- Technologies Cloud : Pratiques natives du cloud, DevOps, CI/CD',
      description5: '- Conteneurisation : Docker, Kubernetes, OpenShift',
      description6: '- Gestion de base de données : SQL, NoSQL',
      description7: '- Microservices, et informatique sans serveur',
      description8: '- Développement de Jeux vidéo',
      description9: '- CMS : WordPress',
      description10: '- Approches recommandées en cybersécurité',
      description11: '- Méthodes efficaces pour le SEO, GEO et la gestion de campagnes publicitaires',
      description12: '- Principes clés pour l’ASO (optimisation des stores d’applications)',
      description13:
        '- Suivi et analyses : GTM, implémentation de tracker d’événements, SKAN, MACT, suivi des résultats via dashboards',
      description14: '- Optimisation de votre entonnoir de conversion',
      description15: "- Intégration d'APIs et stratégie digitale axée sur votre retour sur investissement",
      description16: (
        <>
          - GitHub Repositories:{' '}
          <a
            href="https://github.com/Jean-Joooo?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
            title="Voir Mes Codes"
            className="custom-link"
          >
            Voir Mes Codes
          </a>
        </>
      ),
      description17: (
        <>
          - Profile Dev Unity:{' '}
          <a
            href="https://play.unity.com/en/user/22629c72-4d39-48ff-bed8-08491b47a243"
            target="_blank"
            rel="noopener noreferrer"
            title="Voir Mes Créations de Jeux"
            className="custom-link"
          >
            Voir Mes Créations de Jeux
          </a>
        </>
      ),
      description18:
        "Mon objectif est d'amplifier votre vision, augmenter votre ROAS, et transformer vos concepts en un chef-d'œuvre numérique.",
    },
    projects: {
      title: 'Réalisations',
    },
    skills: {
      title: "J'utilise principalement",
    },
    contacts: {
      name: 'Nom/ Raison Sociale',
      placeholder: 'Ashley Giraud/ Entreprise XYZ',
      PhoneNumber: 'Numéro de téléphone',
      Subject: 'Sujet',
      message: 'Écrivez votre message',
      sendBtn: 'Envoyer',
    },
  },
};

const TranslationProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  const translate = (key, section) => {
    return translations[language] &&
      translations[language][section] &&
      translations[language][section][key]
      ? translations[language][section][key]
      : key;
  };

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
  };

  return (
    <TranslationContext.Provider
      value={{ translate, changeLanguage, currentLanguage: language }}
    >
      {children}
    </TranslationContext.Provider>
  );
};

const useTranslation = () => {
  return useContext(TranslationContext);
};

export { TranslationProvider, useTranslation };
